import { CESubscriptionAttributesBase } from './ce-subscription-attributes-base'


export class CESubscriptionAttributes extends CESubscriptionAttributesBase {

}